import React, { useCallback, useEffect, useState } from "react";
import Page from "../../types/Page";
import Layout from "../../components/Layout";
import PageHeader from "../../components/PageHeader";
import { Button, Col, Form, FormLabel, Row, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { Heading } from "@lomarengas/design-system";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useAuthUser } from "../../features/auth/authHooks";
import Select from "react-select";
import {
  getAccommodationDetailsBasicAsync,
  getAccommodationImagesAsync,
  selectAccommodationDetailsBasic,
  selectAccommodationImages,
} from "../AccommodationsPage/accommodationSlice";

import {
  clearInputErrors,
  selectInputErrors,
} from "../../features/errors/errorsSlice";
import {
  AddBookingOwnerNote,
  BookingDetails,
  BookingDetailsOrderItem,
  BookingType,
  CancelBookingCommand,
  cancelOwnersOwnBookingAsync,
  clearExtraBookingItems,
  getBookingDetailsAsync,
  getExtraBookingDetailsAsync,
  saveBookingOwnerNoteAsync,
  selectBookingItem,
  selectExtraBookingItems,
} from "./bookingsSlice";
import {
  bookingTypeEnumToTranslatedText,
  getAccommodationTranslationItem,
  getEndTimeFromBooking,
  getStartTimeFromBooking,
  JsDateToString,
} from "../../common/misc";
import { addStatusToast } from "../../components/StatusToast";
import InputErrorsDisplay from "../../features/errors/InputErrorsDisplay";
import EditBookingModalWrapper from "./EditBookingModalWrapper";
import { LOADING_STATUS } from "../../common/constants";
import {
  getCountriesAsync,
  selectCountryItems,
} from "../../features/countries/countriesSlice";

const BookingsBookingPageType: Page = {
  ActiveTab: "Bookings",
  DisplayName: "Varaus 1234",
  DisplayParentName: "Varauskalenteri / Varaus",
  LinkUrl: "/bookings/booking",
  Path: "/bookings/booking",
  RouteName: "bookings/booking",
};

const BookingsBookingPage = () => {
  const { isOwnerUser } = useAuthUser();
  const params = useParams();
  const dispatch = useAppDispatch();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const bookingNumber = urlParams.get("bookingNumber");
  const accommodationId = urlParams.get("accommodationId");
  const { ownerAccountId } = useAuthUser();
  const countries = useAppSelector(selectCountryItems);
  const [textareaValue, setTextareaValue] = useState("");
  const [cancelTextAreaValue, setCancelTextAreaValue] = useState("");
  const [editBookingModalOpen, setEditBookingModalOpen] = useState(false);

  const [bookingLoadingStatus, setBookingLoadingStatus] =
    useState<LOADING_STATUS>(LOADING_STATUS.IDLE);
  const [bookingCancellingStatus, setBookingCancellingStatus] =
    useState<LOADING_STATUS>(LOADING_STATUS.IDLE);
  const handleEditBookingModalClose = () => {
    // setFrontPageAccommodationBookingsRefreshTrigger((prev) => prev + 1); // Increment to trigger re-fetch
    setEditBookingModalOpen(false);
  };
  const inputErrors = useAppSelector(selectInputErrors);
  const countryOptions = countries.map((country) => {
    return { value: country.id, label: country.name };
  });

  const getCountryName = (countryId: string | undefined) => {
    var first = countryOptions.find(
      (country) => country.value.toLowerCase() === countryId.toLowerCase(),
    );
    if (first) {
      return first.label;
    } else {
      return "";
    }
  };
  const accommodationDetailsBasic = useAppSelector(
    selectAccommodationDetailsBasic,
  );
  //const accommodationImages = useAppSelector(selectAccommodationImages);

  const booking = useAppSelector(selectBookingItem);
  const extraBookings = useAppSelector(selectExtraBookingItems);
  let bookingStartDate: Date;
  let bookingEndDate: Date;
  const initFetch = useCallback(async () => {
    setBookingLoadingStatus(LOADING_STATUS.LOADING);
    // clear old extras before fetching
    dispatch(clearExtraBookingItems());
    dispatch(
      getCountriesAsync({ PageNumber: 1, PageSize: 100000, searchString: "" }),
    );
    const bookingDetailsAction = await dispatch(
      getBookingDetailsAsync(params.bookingId),
    ).unwrap();
    // Resolve accommodationId: either from params or from booking data
    let resolvedAccommodationId = accommodationId;
    if (!resolvedAccommodationId) {
      resolvedAccommodationId =
        bookingDetailsAction.bookingResult.result.bookingOrderItems?.[0]
          ?.accommodationId ?? null;
    }
    if (resolvedAccommodationId) {
      // Fetch accommodation details concurrently
      await Promise.all([
        dispatch(getAccommodationDetailsBasicAsync(resolvedAccommodationId)),
        //dispatch(getAccommodationImagesAsync(resolvedAccommodationId)),
      ]);
    }
    //dispatch(getBookingDetailsAsync(params.bookingId));
    // Fetch extra bookings if they exist
    if (
      bookingDetailsAction.bookingResult.result.extraBookingResponses?.length >
      0
    ) {
      for (const extraBookingResponse of bookingDetailsAction.bookingResult
        .result.extraBookingResponses) {
        if (!extraBookingResponse.isCancelled) {
          await dispatch(getExtraBookingDetailsAsync(extraBookingResponse.id));
        }
      }
    }
    setBookingLoadingStatus(LOADING_STATUS.IDLE);
  }, [dispatch, accommodationId, params.bookingId]);
  useEffect(() => {
    initFetch();
  }, [initFetch]);

  useEffect(() => {
    let bookingResponse = null;
    if (
      booking?.bookingResponses === undefined ||
      booking?.bookingResponses === null
    ) {
      bookingResponse = booking;
    } else {
      bookingResponse = booking?.bookingResponses?.[0];
    }

    if (bookingResponse?.ownerBookingNotes?.length > 0) {
      setTextareaValue(bookingResponse.ownerBookingNotes[0].noteText || "");
    }
  }, [booking]);
  /*
    useEffect(() => {
      if (accommodationDetailsBasic != null) {
        dispatch(
          getIdentityAddressDetailsAsync(accommodationDetailsBasic.addressId),
        );
      }
    }, [accommodationDetailsBasic]);
     */
  /*
    let cabinName = getAccommodationTranslationItem(
      "fi_FI",
      "AccommodationName",
      accommodationDetailsBasic,
    );
     */
  const calculateBookingTotalBuyPrice = (
    bookingOrderItems: BookingDetailsOrderItem[],
  ) => {
    let bookingTotalBuyPrice: number = 0;
    bookingOrderItems.map((bookingOrderItem) => {
      if (bookingOrderItem.orderItemType == 4) {
        return <></>;
      }
      let orderItemPurchasePrice = 0;
      //let bookingOrderItemOwnerId = bookingOrderItem.ownerAccountId;
      if (
        bookingOrderItem.realOwnerAccountId &&
        bookingOrderItem.realOwnerAccountId.toLowerCase() ===
          ownerAccountId.toLowerCase()
      ) {
        //bookingOrderItemOwnerId = bookingOrderItem.realOwnerAccountId;
        orderItemPurchasePrice =
          bookingOrderItem?.purchasePricesResponse?.ownerPurchasePrice;
      } else {
        if (
          bookingOrderItem.ownerAccountId &&
          bookingOrderItem.ownerAccountId.toLowerCase() ===
            ownerAccountId.toLowerCase()
        ) {
          orderItemPurchasePrice =
            bookingOrderItem?.purchasePricesResponse?.sitePurchasePrice;
        }
      }
      bookingTotalBuyPrice += orderItemPurchasePrice;
    });
    return bookingTotalBuyPrice;
  };

  //let bookingTotalBuyPrice: number = 0;
  const renderBookingOrderItems = (
    bookingOrderItems: BookingDetailsOrderItem[],
  ) => {
    let first: boolean = true;
    return bookingOrderItems.map((bookingOrderItem) => {
      if (
        bookingOrderItem.orderItemType == 4 ||
        bookingOrderItem.itemName.toLowerCase() == "if peruutusturva" ||
        bookingOrderItem.itemName.toLowerCase().includes("toimitus") ||
        bookingOrderItem.itemName.toLowerCase().includes("muutoskulu")
      ) {
        return <></>;
      }
      let orderItemPurchasePrice = 0;
      //let bookingOrderItemOwnerId = bookingOrderItem.ownerAccountId;
      if (
        bookingOrderItem.realOwnerAccountId &&
        bookingOrderItem.realOwnerAccountId.toLowerCase() ===
          ownerAccountId.toLowerCase()
      ) {
        //bookingOrderItemOwnerId = bookingOrderItem.realOwnerAccountId;
        orderItemPurchasePrice =
          bookingOrderItem?.purchasePricesResponse?.ownerPurchasePrice;
      } else {
        if (
          bookingOrderItem.ownerAccountId &&
          bookingOrderItem.ownerAccountId.toLowerCase() ===
            ownerAccountId.toLowerCase()
        ) {
          orderItemPurchasePrice =
            bookingOrderItem?.purchasePricesResponse?.sitePurchasePrice;
        }
      }

      // bookingTotalBuyPrice += orderItemPurchasePrice;
      let orderItemName: string = bookingOrderItem.itemName;
      if (first) {
        first = false;
        if (bookingOrderItem.accommodationNumber != 0) {
          orderItemName =
            bookingOrderItem.accommodationNumber.toString() +
            " " +
            orderItemName;
        }
        let bookingOrderStartDateString = JsDateToString(
          new Date(bookingOrderItem.startDateTime),
          true,
          true,
          true,
          "",
          false,
          false,
        );
        let bookingOrderEndDateString = JsDateToString(
          new Date(bookingOrderItem.endDateTime),
          true,
          true,
          true,
          "",
          false,
          false,
        );
        orderItemName += " " + bookingOrderStartDateString;
        if (bookingOrderStartDateString != bookingOrderEndDateString) {
          orderItemName += " - " + bookingOrderEndDateString;
        }
      }
      return (
        <React.Fragment key={bookingOrderItem.id}>
          <tr>
            <th scope="row">{orderItemName}</th>
            <td>
              <span className="d-md-none">Määrä: </span>
              {bookingOrderItem?.units}
            </td>
            <td>
              <span className="d-md-none">Aikuiset: </span>
              {bookingOrderItem?.amountOfAdults}
            </td>
            <td>
              <span className="d-md-none">Lapset: </span>
              {bookingOrderItem?.amountOfChildren}
            </td>
            {isOwnerUser && (
              <td>
                <span className="d-md-none">Hinta: </span>
                {orderItemPurchasePrice} €
              </td>
            )}
          </tr>
        </React.Fragment>
      );
    });
  };
  const renderExtraBookingResponses = (extraBookings: BookingDetails[]) => {
    const parseDate = (str?: string) => {
      if (!str) return Number.POSITIVE_INFINITY; // sort invalid/missing to end
      const [datePart, timePart] = str.split("T");
      if (!datePart || !timePart) return Number.POSITIVE_INFINITY;
      const [day, month, year] = datePart.split("-").map(Number);
      const [hours, minutes] = timePart.split(":").map(Number);
      return new Date(year, month - 1, day, hours, minutes).getTime();
    };

    return extraBookings
      .filter((extraBooking) => !extraBooking.isCancelled)
      .slice()
      .sort((a, b) => {
        const aEarliest = Math.min(
          ...a.bookingOrderItems.map((item) => parseDate(item.startDateTime)),
        );
        const bEarliest = Math.min(
          ...b.bookingOrderItems.map((item) => parseDate(item.startDateTime)),
        );
        return aEarliest - bEarliest; // earliest first
      })
      .map((extraBooking) => (
        <React.Fragment key={extraBooking.id}>
          <Heading
            Title={`Lisävaraus ${extraBooking.bookingNumber}`}
            Level={4}
          />
          <table className="table mt-16 mb-0">
            <thead>
              <tr>
                <th scope="col">Palvelu</th>
                <th scope="col">Määrä</th>
                <th scope="col">Aikuisia</th>
                <th scope="col">Lapsia</th>
                {isOwnerUser && <th scope="col">Hinta</th>}
              </tr>
            </thead>
            <tbody>
              {extraBooking.bookingOrderItems?.length > 0 &&
                renderBookingOrderItems(extraBooking.bookingOrderItems)}
            </tbody>
            {isOwnerUser && (
              <tfoot>
                <tr className="bg-light">
                  <td className="text-md-end bg-light" colSpan={4}>
                    Yhteensä
                  </td>
                  <td className="bg-light">
                    {calculateBookingTotalBuyPrice(
                      extraBooking.bookingOrderItems,
                    ).toFixed(2)}{" "}
                    €
                  </td>
                </tr>
              </tfoot>
            )}
          </table>

          {extraBooking?.customerBookingNotes?.length > 0 && (
            <Heading
              Title="Lisävarauksen asiakkaan lisätiedot"
              Level={5}
              CssClass="my-24"
            />
          )}
          {extraBooking?.customerBookingNotes?.map((note) => (
            <p key={note?.noteText}>
              {note?.noteText?.split("\n").map((line, index) => (
                <span className="d-block" key={index}>
                  {line}
                </span>
              ))}
            </p>
          ))}

          {extraBooking?.ownerBookingNotes?.length > 0 && (
            <Heading
              Title="Lisävarauksen omistajan lisätiedot"
              Level={5}
              CssClass="my-24"
            />
          )}
          {extraBooking?.ownerBookingNotes?.map((note) => (
            <p key={note?.noteText}>
              {note?.noteText?.split("\n").map((line, index) => (
                <span className="d-block" key={index}>
                  {line}
                </span>
              ))}
            </p>
          ))}
        </React.Fragment>
      ));
  };

  const handleTextareaChange = (e: { target: { value: string } }) => {
    setTextareaValue(e.target.value);
  };
  const handleCancelTextareaChange = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setCancelTextAreaValue(e.target.value);
  };
  const saveNewBookingOwnerNote = () => {
    if (!textareaValue.trim()) {
      addStatusToast({
        Message: `Kommentti ei voi olla tyhjä!`,
      });
      return;
    }

    let ownerBookingNote: AddBookingOwnerNote = new (class
      implements AddBookingOwnerNote
    {
      ownerId: string;
      bookingId: string;
      ownerBookingNote: string;
    })();
    ownerBookingNote.ownerId = ownerAccountId;
    ownerBookingNote.bookingId = params.bookingId;
    ownerBookingNote.ownerBookingNote = textareaValue;

    dispatch(saveBookingOwnerNoteAsync(ownerBookingNote)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(
          addStatusToast({
            Message: `Omistajan kommentti tallennettu!`,
          }),
        );
        setTextareaValue("");
        dispatch(getBookingDetailsAsync(params.bookingId));
        dispatch(clearInputErrors());
      }
    });
  };

  const cancelOwnerOwnBooking = () => {
    const confirmThatOwnerWantsToCancelBooking = confirm(
      "Oletko varma että haluat perua varauksen?",
    );
    if (!confirmThatOwnerWantsToCancelBooking) {
      return; // user cancelled, do nothing
    }
    let cancelOwnerOwnBookingCommand: CancelBookingCommand = new (class
      implements CancelBookingCommand
    {
      bookingId: string;
      reasonOfCancellation: string;
    })();
    cancelOwnerOwnBookingCommand.bookingId = params.bookingId;
    cancelOwnerOwnBookingCommand.reasonOfCancellation = cancelTextAreaValue;
    setBookingCancellingStatus(LOADING_STATUS.LOADING);
    dispatch(cancelOwnersOwnBookingAsync(cancelOwnerOwnBookingCommand)).then(
      (res) => {
        if (res.meta.requestStatus === "fulfilled") {
          dispatch(
            addStatusToast({
              Message: `Varaus peruttu!`,
            }),
          );
          setBookingCancellingStatus(LOADING_STATUS.IDLE);
          setCancelTextAreaValue("");
          dispatch(getBookingDetailsAsync(params.bookingId));
          dispatch(clearInputErrors());
        }
      },
    );
  };
  const renderBookingDetails = () => {
    let bookingResponse = null;
    if (
      booking.bookingResponses === undefined ||
      booking.bookingResponses === null
    ) {
      //something wrong with the booking
      bookingResponse = booking;
    } else {
      bookingResponse = booking.bookingResponses[0];
    }
    bookingStartDate = getStartTimeFromBooking(bookingResponse);
    bookingEndDate = getEndTimeFromBooking(bookingResponse);
    let adults: number, children: number;
    if (
      bookingResponse.bookingOrderItems != undefined &&
      bookingResponse.bookingOrderItems.length > 0
    ) {
      const orderItem = bookingResponse.bookingOrderItems[0];
      adults = orderItem.amountOfAdults;
      children = orderItem.amountOfChildren;
    }
    //console.log(bookingResponse);
    let mainBookingTotalBuyPrice: number;
    return (
      <>
        {bookingResponse.isCancelled && (
          <>
            <Row xs={1} md={2}>
              <Col>
                <h1
                  className="border-bottom pb-16 mb-16"
                  style={{ color: "red" }}
                >
                  PERUTTU VARAUS
                </h1>
              </Col>
            </Row>
            <Row>
              <Col>
                <h3
                  className="border-bottom pb-16 mb-16"
                  style={{ color: "red" }}
                >
                  Peruutuksen syy:
                  {bookingResponse?.reasonOfCancellation
                    ?.split("\n")
                    .map((line, index) => <p key={index}>{line}</p>)}
                </h3>
              </Col>
            </Row>
          </>
        )}
        <Row xs={1} md={2}>
          <Col>
            <div className="border-bottom pb-16 mb-16">
              <FormLabel>Varaus pvm</FormLabel>
              <div>
                {JsDateToString(
                  new Date(bookingResponse.createdAt),
                  true,
                  true,
                  true,
                  "",
                  false,
                  false,
                )}
              </div>
            </div>
          </Col>
          <Col>
            <div className="border-bottom pb-16 mb-16">
              <FormLabel>Henkilömäärä</FormLabel>
              <div>
                {adults} aikuista {children > 0 && ", " + children + " lasta"}
              </div>
            </div>
          </Col>
        </Row>
        <Row xs={1} md={2}>
          <Col>
            <div className="border-bottom pb-16 mb-16">
              <FormLabel>Varauksen tyyppi</FormLabel>
              <div>
                {bookingTypeEnumToTranslatedText(bookingResponse.bookingType)}
              </div>
            </div>
          </Col>
          <Col>
            <div className="border-bottom pb-16 mb-16">
              <FormLabel>Sisään- ja uloskirjautumisaika</FormLabel>
              <div>
                {JsDateToString(
                  bookingStartDate,
                  true,
                  true,
                  true,
                  " klo ",
                  true,
                  true,
                ) +
                  " - " +
                  JsDateToString(
                    bookingEndDate,
                    true,
                    true,
                    true,
                    " klo ",
                    true,
                    true,
                  )}
              </div>
            </div>
          </Col>
        </Row>
        {bookingResponse.bookingType != BookingType.OwnerOwn &&
          bookingResponse.bookingType != BookingType.OwnerReported && (
            <Row xs={1} md={2}>
              <Col>
                <div className="border-bottom pb-16 mb-16">
                  <FormLabel>Varaajan tiedot</FormLabel>
                  <div>
                    {bookingResponse.payerFirstName}{" "}
                    {bookingResponse.payerLastName}
                    {/*}
                    <br />
                    {bookingResponse.payerStreetAddress}
                    <br />
                    {bookingResponse.payerPostCode}{" "}
                    {bookingResponse.payerPostCity}
                    */}
                    <br />
                    {bookingResponse.payerPhoneNumber != undefined && (
                      <a href={`tel:${bookingResponse.payerPhoneNumber}`}>
                        {bookingResponse.payerPhoneNumber}
                      </a>
                    )}
                    <br />
                    {bookingResponse.payerEmailAddress != undefined && (
                      <a href={`mailto:${bookingResponse.payerEmailAddress}`}>
                        {bookingResponse.payerEmailAddress}
                      </a>
                    )}
                  </div>
                </div>
              </Col>
              <Col>
                <div className="border-bottom pb-16 mb-16">
                  <FormLabel>Virkailija</FormLabel>
                  <div>
                    {bookingResponse.authorFirstName}{" "}
                    {bookingResponse.authorLastName}
                    {/*}
                    <br />
                    {bookingResponse.authorEmail != undefined && (
                      <a href={`mailto:${bookingResponse.authorEmail}`}>
                        {bookingResponse.authorEmail}
                      </a>
                    )}
                    {*/}
                  </div>
                </div>
              </Col>
            </Row>
          )}
        <Heading
          Title={"Varauksen " + bookingResponse.bookingNumber + " palvelut"}
          Level={4}
          CssClass="mt-16 mb-24"
        />
        <table className="table mb-0">
          <thead>
            <tr>
              <th scope="col">Palvelu</th>
              <th scope="col">Määrä</th>
              <th scope="col">Aikuisia</th>
              <th scope="col">Lapsia</th>
              {isOwnerUser && <th scope="col">Hinta</th>}
            </tr>
          </thead>
          <tbody>
            {bookingResponse.bookingOrderItems != undefined &&
              bookingResponse.bookingOrderItems.length > 0 &&
              renderBookingOrderItems(bookingResponse.bookingOrderItems)}
          </tbody>
          {isOwnerUser && (
            <tfoot>
              <tr className="bg-light">
                <td className="text-md-end bg-light" colSpan={4}>
                  Yhteensä
                </td>
                <td className="bg-light">
                  {calculateBookingTotalBuyPrice(
                    bookingResponse.bookingOrderItems,
                  ).toFixed(2)}{" "}
                  €
                </td>
              </tr>
            </tfoot>
          )}
        </table>
        {isOwnerUser &&
          !bookingResponse.isCancelled &&
          (bookingResponse.bookingType === BookingType.TemporaryDisabled ||
            bookingResponse.bookingType === BookingType.OwnerOwn) && (
            <div className="d-grid d-md-flex justify-content-md-end mt-24  d-print-none">
              <Button
                variant="primary"
                onClick={() => setEditBookingModalOpen(true)}
              >
                Muokkaa varausta
              </Button>
            </div>
          )}
        {extraBookings != undefined &&
          extraBookings.length > 0 &&
          renderExtraBookingResponses(extraBookings)}
        <Heading
          Title={"Lisätiedot varaus " + bookingResponse.bookingNumber}
          Level={4}
          CssClass="my-24"
        />
        <Row xs={1} md={2} className="gy-16">
          <Col>
            <FormLabel>Varaajan lisätiedot</FormLabel>
            {bookingResponse?.customerBookingNotes?.map(
              (customerBookingNote) => {
                return (
                  <p key={customerBookingNote?.noteText}>
                    {customerBookingNote?.noteText
                      ?.split("\n")
                      .map((line, index) => (
                        <span className="d-block" key={index}>
                          {line}
                        </span>
                      ))}
                  </p>
                );
              },
            )}
          </Col>
          <Col>
            <FormLabel>Omistajan lisätiedot</FormLabel>
            {bookingResponse?.ownerBookingNotes?.map((ownerBookingNote) => {
              return (
                <p key={ownerBookingNote?.noteText}>
                  {ownerBookingNote?.noteText
                    ?.split("\n")
                    .map((line, index) => (
                      <span className="d-block" key={index}>
                        {line}
                      </span>
                    ))}
                </p>
              );
            })}
            {isOwnerUser && (
              <>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={textareaValue}
                  onChange={(e) => handleTextareaChange(e)}
                  placeholder="Lisää tai muokkaa kommenttia..."
                />
                <div className="d-grid d-md-flex justify-content-md-end mt-24 d-print-none">
                  <Button
                    variant="primary"
                    onClick={() => saveNewBookingOwnerNote()}
                  >
                    Tallenna
                  </Button>
                </div>
              </>
            )}
            {isOwnerUser &&
              !bookingResponse.isCancelled &&
              (bookingResponse.bookingType === BookingType.TemporaryDisabled ||
                bookingResponse.bookingType === BookingType.OwnerOwn) && (
                <div className="d-print-none mt-24">
                  <FormLabel>Peruutuksen syy</FormLabel>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={cancelTextAreaValue}
                    onChange={(e) => handleCancelTextareaChange(e)}
                  />

                  <div className="d-grid d-md-flex justify-content-md-end mt-24">
                    <Button
                      variant="danger"
                      onClick={() => cancelOwnerOwnBooking()}
                    >
                      Peruuta varaus
                    </Button>
                    {bookingCancellingStatus == LOADING_STATUS.LOADING && (
                      <>
                        <div className="d-flex gap-16 align-items-center">
                          <Spinner animation="border" />
                          <span> Varausta perutaan...</span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
          </Col>
        </Row>
        <Row xs={1} md={2} className="gy-16">
          {bookingResponse.finalClient != null && (
            <div>
              <FormLabel>Matkanjärjestäjän loppuasiakas</FormLabel>
              <div>{bookingResponse.finalClient}</div>
              <div>{bookingResponse.finalClientCompany ?? ""}</div>
              <div>{bookingResponse.finalClientStreetAddress ?? ""}</div>
              <div>
                {bookingResponse.finalClientZipCode ?? ""}
                {" " + bookingResponse.finalClientCity ?? ""}
              </div>
              <div>{bookingResponse.finalClientPhone ?? ""}</div>
              <div>{bookingResponse.finalClientEmail ?? ""}</div>
              <div>
                {getCountryName(bookingResponse.finalClientCountry) ?? ""}
              </div>
            </div>
          )}
        </Row>
      </>
    );
  };
  let varauksenTiedotText = "Varauksen tiedot";
  let bookingResponse = null;
  if (booking != null) {
    if (
      booking.bookingResponses === undefined ||
      booking.bookingResponses === null
    ) {
      //something wrong with the booking
      bookingResponse = booking;
    } else {
      bookingResponse = booking.bookingResponses[0];
    }
  }
  if (bookingResponse != null) {
    varauksenTiedotText =
      "Varauksen " + bookingResponse.bookingNumber + " tiedot";
  }

  return (
    <div className={BookingsBookingPageType.RouteName}>
      <Layout CurrentPage={BookingsBookingPageType}>
        <PageHeader
          Title={bookingNumber}
          SubTitle={BookingsBookingPageType.DisplayParentName}
          Print={true}
        />
        {/*
        {accommodationDetailsBasic == undefined && (
          <>
            Kohteen tietoja ladataan...
            <Spinner animation="border" />
          </>
        )}
        */}

        {bookingLoadingStatus === LOADING_STATUS.LOADING && (
          <>
            <div className="d-flex gap-16 align-items-center">
              <Spinner animation="border" />
              <span> Varauksen tietoja ladataan...</span>
            </div>
          </>
        )}
        {booking != undefined &&
          bookingLoadingStatus !== LOADING_STATUS.LOADING &&
          renderBookingDetails()}
      </Layout>
      {editBookingModalOpen && (
        <EditBookingModalWrapper
          booking={bookingResponse}
          accommodation={accommodationDetailsBasic}
          bookingStartDate={bookingStartDate}
          bookingEndDate={bookingEndDate}
          showModal={editBookingModalOpen}
          setParentShowBookingModal={handleEditBookingModalClose}
          callParentInitFetch={initFetch}
        />
      )}
      <InputErrorsDisplay inputErrors={inputErrors} />
    </div>
  );
};

export default BookingsBookingPage;
